type HorizontalArrowsProps = {
  width: number;
  centerX?: number;
  leftLabel?: string;
  rightLabel?: string;
  /** Height reserved for the arrow row (used to size the containing SVG). */
  height?: number;
};

const CENTER_GAP = 50;

/**
 * Two outward-pointing text arrows with labels, intended to render below a
 * DivergingBarChart to describe what the left and right sides represent.
 */
export const HorizontalArrows = ({
  width,
  centerX: centerXProp,
  leftLabel,
  rightLabel,
  height = 25,
}: HorizontalArrowsProps) => {
  const centerX = centerXProp ?? width / 2;

  return (
    <svg width="100%" height={height}>
      {leftLabel && (
        <text
          x={centerX - CENTER_GAP}
          y={0}
          textAnchor="end"
          dominantBaseline="hanging"
        >
          {`← ${leftLabel}`}
        </text>
      )}
      {rightLabel && (
        <text
          x={centerX + CENTER_GAP}
          y={0}
          textAnchor="start"
          dominantBaseline="hanging"
        >
          {`${rightLabel} →`}
        </text>
      )}
    </svg>
  );
};
